var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSms = function SvgSms(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#838485",
    d: "M3.776 9.226c.676-2.942 2.88-5.229 5.69-5.901l.224-.054a9.85 9.85 0 0 1 4.593 0l.381.092c2.713.649 4.842 2.857 5.495 5.698l.089.386a9.96 9.96 0 0 1 0 4.455c-.678 2.948-3.19 5.025-6.076 5.025h-1.061a.87.87 0 0 0-.797.563c-.481 1.23-1.825 1.835-2.998 1.333l-.118-.05c-2.711-1.16-4.732-3.646-5.419-6.635a11 11 0 0 1-.003-4.912"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8.696 8.308a.75.75 0 0 0 0 1.5h6.032a.75.75 0 1 0 0-1.5zm0 3.456a.75.75 0 0 0 0 1.5h3.839a.75.75 0 0 0 0-1.5z"
  })));
};
export default SvgSms;